import { useState, useEffect } from "react";
import { request } from "hooks/useOkoApi/useOkoApi";
import { logApi, LogLevel } from "utils/sentryLogger";

const FALLBACK_MODELS = {
  google: [
    { value: "gemini-3.5-flash", label: "Gemini 3.5 Flash (Balanced)" },
    { value: "gemini-3.8-flash", label: "Gemini 3.8 Flash" },
    { value: "gemini-4-argon", label: "Gemini 4 Argon (Most Capable)" },
    { value: "gemini-2.5-pro", label: "Gemini 2.5 Pro" },
    { value: "gemini-2.0-flash", label: "Gemini 2.0 Flash" },
    { value: "gemini-3-flash-preview", label: "Gemini 3 Flash Preview (Experimental)" },
    { value: "gemini-3.1-pro-preview", label: "Gemini 3.1 Pro Preview (Experimental)" },
  ],
  anthropic: [
    { value: "claude-sonnet-4-5", label: "Claude Sonnet 4.5 (Latest)" },
    { value: "claude-sonnet-4-6", label: "Claude Sonnet 4.6" },
    { value: "claude-sonnet-4", label: "Claude Sonnet 4" },
    { value: "claude-opus-4-6", label: "Claude Opus 4.6" },
    { value: "claude-opus-4-1", label: "Claude Opus 4.1" },
    { value: "claude-haiku-4-5", label: "Claude Haiku 4.5 (Fast)" },
  ],
  openai: [
    { value: "gpt-4o", label: "GPT-4o (Latest)" },
    { value: "gpt-4o-mini", label: "GPT-4o Mini (Fast)" },
    { value: "gpt-4.1", label: "GPT-4.1" },
    { value: "gpt-4.1-mini", label: "GPT-4.1 Mini" },
    { value: "gpt-4.1-nano", label: "GPT-4.1 Nano" },
  ],
};

export const useAvailableModels = (defaultProvider = "google", defaultModel = "gemini-3.5-flash") => {
  const [provider, setProvider] = useState(defaultProvider);
  const [modelName, setModelName] = useState(defaultModel);
  const [modelOptions, setModelOptions] = useState(null);
  const [modelsLoading, setModelsLoading] = useState(true);

  useEffect(() => {
    const fetchModels = async () => {
      try {
        const response = await request("session_summary/available_models", { method: "GET" });
        setModelOptions(response);
      } catch (error) {
        console.error("Failed to fetch models:", error);
        logApi("Failed to fetch available models", {
          level: LogLevel.WARNING,
          endpoint: "session_summary/available_models",
          statusCode: error?.status,
          errorMessage: error?.detail || error?.message,
        });
        setModelOptions(FALLBACK_MODELS);
      } finally {
        setModelsLoading(false);
      }
    };
    fetchModels();
  }, []);

  const handleProviderChange = (newProvider) => {
    setProvider(newProvider);
    if (modelOptions && modelOptions[newProvider] && modelOptions[newProvider].length > 0) {
      setModelName(modelOptions[newProvider][0].value);
    }
  };

  return {
    provider,
    setProvider: handleProviderChange,
    modelName,
    setModelName,
    modelOptions,
    modelsLoading,
  };
};
